import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import style from './Textarea.module.scss'

const Textarea = ({ className, disabled, error, id, label, placeholder, value, register }) => {
  const { color, colabelNeutralMid, colabelNeutralDark } = useContext(ClientContext)

  return (
    <div className={classNames(style['textarea'], className, error && style.error, color && style.colabel)}>
      <label className="input-label" htmlFor={id} style={color && { color: colabelNeutralDark }}>
        {label}
      </label>
      <textarea
        id={id}
        placeholder={placeholder}
        disabled={disabled}
        {...register}
        style={color && {
          borderColor: colabelNeutralMid,
          color: colabelNeutralDark
        }}
      >
        {value}
      </textarea>
    </div>
  )
}

export default Textarea
